document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('section[data-section-id="template--28699874263365__video"]');
  if (!section) return;

  var videos = Array.prototype.slice.call(section.querySelectorAll('video'));
  if (!videos.length) return;

  videos.forEach(function (v) {
    v.removeAttribute('autoplay');
    v.removeAttribute('loop');
    v.loop = false;
    v.setAttribute('playsinline', '');
    v.pause();
    v.currentTime = 0;
  });

  function activeVideo() {
    for (var i = 0; i < videos.length; i++) {
      if (videos[i].offsetWidth > 0 && getComputedStyle(videos[i]).display !== 'none') return videos[i];
    }
    return videos[0];
  }

  var ICON_SOUND_ON = '<svg viewBox="0 0 24 24"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16 8.5a5 5 0 0 1 0 7"/><path d="M18.5 6a8.5 8.5 0 0 1 0 12"/></svg>';
  var ICON_SOUND_OFF = '<svg viewBox="0 0 24 24"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M17 9.5l5 5"/><path d="M22 9.5l-5 5"/></svg>';
  var ICON_FULLSCREEN = '<svg viewBox="0 0 24 24"><path d="M4 9V4h5"/><path d="M20 9V4h-5"/><path d="M4 15v5h5"/><path d="M20 15v5h-5"/></svg>';

  var container = section.querySelector('.video__media-container') || section;
  if (!container.style.position) container.style.position = 'relative';

  var icon = document.createElement('div');
  icon.className = 'zerezza-play-icon';
  icon.innerHTML = '<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>';
  icon.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
  icon.style.pointerEvents = 'none';
  container.appendChild(icon);
    var controls = document.createElement('div');
  controls.className = 'zerezza-vcontrols';
  controls.innerHTML = '<button type="button" class="zerezza-vbtn zerezza-fs-btn" aria-label="Fullscreen">' + ICON_FULLSCREEN + '</button><button type="button" class="zerezza-vbtn zerezza-sound-btn" aria-label="Mute"></button>';
  controls.style.cssText = 'position:absolute;right:16px;bottom:16px;display:flex;gap:10px;z-index:2147483647;';
  section.appendChild(controls);

  var fsBtn = controls.querySelector('.zerezza-fs-btn');
  var soundBtn = controls.querySelector('.zerezza-sound-btn');
  var userInitiated = false;
  var hasStarted = false;
  var userMuted = false;

  function renderSound() {
    soundBtn.innerHTML = userMuted ? ICON_SOUND_OFF : ICON_SOUND_ON;
  }
  renderSound();

  function playVideo(v) {
    userInitiated = true;
    hasStarted = true;
    v.muted = userMuted;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  section.addEventListener('click', function (e) {
    if (e.target.closest('.zerezza-vcontrols')) return;
    var v = activeVideo();
    if (v.paused) { playVideo(v); } else { userInitiated = false; v.pause(); }
  });

  soundBtn.addEventListener('click', function (e) {
    e.preventDefault(); e.stopPropagation();
    userMuted = !userMuted;
    videos.forEach(function (v) { v.muted = userMuted; });
    renderSound();
  });

  fsBtn.addEventListener('click', function (e) {
    e.preventDefault(); e.stopPropagation();
    var v = activeVideo();
    if (v.paused) playVideo(v);
    if (v.requestFullscreen) {
      v.requestFullscreen().then(function () {
        if (screen.orientation && screen.orientation.lock) screen.orientation.lock('landscape').catch(function () {});
      }).catch(function () { if (v.webkitEnterFullscreen) v.webkitEnterFullscreen(); });
    } else if (v.webkitEnterFullscreen) {
      v.webkitEnterFullscreen();
    }
  });

  document.addEventListener('fullscreenchange', function () {
    var fsEl = document.fullscreenElement;
    videos.forEach(function (v) { v.controls = !!fsEl && fsEl === v; });
    if (!fsEl && screen.orientation && screen.orientation.unlock) { try { screen.orientation.unlock(); } catch (err) {} }
  });

  videos.forEach(function (v) {
    v.addEventListener('ended', function () { userInitiated = false; v.currentTime = 0; });
  });

  setInterval(function () {
    var v = activeVideo();
    videos.forEach(function (x) { if (x !== v && !x.paused) x.pause(); });
    if (!userInitiated && !v.paused) { v.pause(); if (!hasStarted) v.currentTime = 0; }
    var show = v.paused;
    icon.style.opacity = show ? '1' : '0';
    icon.style.transform = 'translate(-50%, -50%) scale(' + (show ? '1' : '0.85') + ')';
  }, 200);
});